import { APIStatus } from '@application/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { createFamilyRelationAsync, updateFamilyRelationAsync, deleteFamilyRelationAsync, getFamilyRelationByIdAsync, getFamilyRelationsByPersonIdAsync } from './familyRelationsThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const familyRelationsSlice = createSlice({
    name: 'familyRelations',
    initialState,
    reducers: {
        clearFamilyRelation: (state) => {
            state.familyRelation = undefined;
        },
        clearFamilyRelations: (state) => {
            state.familyRelations = undefined;
        },
        clearDeletedFamilyRelation: (state) => {
            state.deletedFamilyRelationId = undefined;
        }
    },
    extraReducers: (builder) => {
        // Create Family Relation
        builder
            .addCase(createFamilyRelationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createFamilyRelationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyRelation = action.payload;
            state.apiError = undefined;
        })
            .addCase(createFamilyRelationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        // Update Family Relation
        builder
            .addCase(updateFamilyRelationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateFamilyRelationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyRelation = action.payload;
            state.apiError = undefined;
        })
            .addCase(updateFamilyRelationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        // Delete Family Relation
        builder
            .addCase(deleteFamilyRelationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteFamilyRelationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.deletedFamilyRelationId = action.payload;
            state.apiError = undefined;
        })
            .addCase(deleteFamilyRelationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        // Get Family Relation by ID
        builder
            .addCase(getFamilyRelationByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFamilyRelationByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyRelation = action.payload;
            state.apiError = undefined;
        })
            .addCase(getFamilyRelationByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        // Get Family Relations by Person ID
        builder
            .addCase(getFamilyRelationsByPersonIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFamilyRelationsByPersonIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyRelations = action.payload;
            state.apiError = undefined;
        })
            .addCase(getFamilyRelationsByPersonIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearFamilyRelation, clearFamilyRelations, clearDeletedFamilyRelation } = familyRelationsSlice.actions;
export default familyRelationsSlice.reducer;
